import React from 'react';
import * as S from './SortSelect.styles';
import { ActionMeta, Props } from 'react-select';
import { SortType, sortOptions } from 'src/api/types';
import _ from 'lodash';

interface SortSelectProps extends Omit<Props, 'value' | 'onChange'> {
  value?: SortType;
  onChange: (
    value: { label: string; value: SortType; dir: 'asc' | 'desc' },
    meta: ActionMeta<{ label: string; value: SortType; dir: 'asc' | 'desc' }>,
  ) => void;
}

export const SortSelect: React.FC<SortSelectProps> = ({ onChange, value }) => {
  return (
    <S.StyledSelect
      placeholder="Sort by"
      options={sortOptions}
      onChange={onChange}
      inputId="sort-select"
      value={_.find(sortOptions, (o) => o.value === value)}
      // menuIsOpen={true}
    />
  );
};
